import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProjParams } from 'src/app/config';
import { DashboardFlagService } from 'src/app/dashboard-flag.service';
import Swal from 'sweetalert2';
import html2pdf from 'html2pdf.js';
import { StoreXcibilReportService } from 'src/app/store-xcibil-report.service';
import { FlagService } from 'src/app/flag.service';
import { SharedService } from 'src/app/shared.service';
import { AuthService } from 'src/app/auth.service';
import { Title } from '@angular/platform-browser';
import { ClientDetailsServiceService } from 'src/app/client-details-service.service';

@Component({
  selector: 'app-search-xcibil',
  templateUrl: './search-xcibil.component.html',
  styleUrls: ['./search-xcibil.component.scss'],
})
export class SearchXcibilComponent implements OnInit {

  clientId: string = '';
  secretKey: string = '';
  panNumber: string = '';
  clientIduat: string = '';
  secretKeyuat: string = '';
  panNumberuat: string = '';
  panDetail: any;
  panuatDetail: any;
  panDetailMessage: any;
  uatSearched: boolean = false;
  prodSearched: boolean = false;
  isLoading: boolean = false;
  panuatDetailMessage: any;
  show: boolean  = false;
  showUAT: boolean = false;
reportData: any;
  clientDetail: any;


  constructor(private http: HttpClient, private flagService: DashboardFlagService, private router: Router, private reportService: StoreXcibilReportService, private flagNameService: FlagService, private communicationService: SharedService, private authService: AuthService, private titleService: Title, private clientDetailService: ClientDetailsServiceService) {}

  ngOnInit(): void {
    this.titleService.setTitle('Fetch XCIBIL Report')
    this.flagService.setDashboardFlag(false);
    this.flagService.setPanApiFlag(false);
    this.flagService.setXcibilFlag(true);
    this.flagService.setBankingFlag(false);

    this.flagService.sendMessage('Load');

      this.flagNameService.updateName('xcibil-api');

      // const storedData = this.communicationService.getFormData();
      // this.clientId = storedData.clientId;
      // this.secretKey = storedData.secretKey;
      // this.panNumber = storedData.panNumber;

      // const storedDataUat = this.communicationService.getFormDatauat();
      // this.clientIduat = storedDataUat.clientId;
      // this.secretKeyuat = storedDataUat.secretKey;
      // this.panNumberuat = storedDataUat.panNumber;
      

      this.clientDetailService.getClientUserDetail().subscribe(
        (data) => {
          if (data) {
            this.clientDetail = data.data
            this.clientId = this.clientDetail.client_id;
            this.secretKey = this.clientDetail.secret_key;
            this.clientIduat = this.clientDetail.sandbox_client_id;
            this.secretKeyuat = this.clientDetail.sandbox_secret_key;
          } else {
            console.error('Failed to fetch client details from service');
          }
        },
        (error) => {
          console.error('Error fetching client details:', error);
        }
      );
  }
  response: any

  showDetail: boolean  = false;
  mode : any;

  saveFormData() {
    const formData = {
      clientId: this.clientId,
      secretKey: this.secretKey,
      panNumber: this.panNumber
    };
    this.communicationService.setFormData(formData);
  }

  saveFormDatauat() {
    const formDatauat = {
      clientId: this.clientIduat,
      secretKey: this.secretKeyuat,
      panNumber: this.panNumberuat
    };
    this.communicationService.setFormDatauat(formDatauat);
  }

  deleteFormData() {
    const formData = {
      clientId: '',
      secretKey: '',
      panNumber: ''
    };
    this.communicationService.setFormData(formData);
  }

  deleteFormDatauat() {
    const formDatauat = {
      clientId : '',
      secretKey: '',
      panNumber: ''
    };
    this.communicationService.setFormDatauat(formDatauat);
  }
  searchXCIBIL() {
    if (!this.validateForm()) {
      return;
    }
    this.deleteFormDatauat();
    this.showDetail = false;
    this.isLoading = true;
    const url = ProjParams.apiurlNew + `public/apiRoute/generateXcibilReport/?pan_no=${this.panNumber}`;
  
    const headers = new HttpHeaders({
      'clientId': this.clientId,
      'secretKey': this.secretKey
    });
  
    this.http.get(url, { headers }).subscribe(
      (response: any) => {
        this.isLoading = false;
        this.response = response
        this.show = true
        this.mode = 'P'
  

        if(response.message ===  'Service is Not Active ')
          {
          this.panDetailMessage = response.message;
          }
        else if(response.message ===  'Contact Support to recharge the Hits')
          {
          this.panDetailMessage = response.message;
          }else {
          this.showDetail = true;
          this.panDetail = response.data
          this.reportService.setPanuatDetail(response.data); 
          this.reportService.setPan(this.panNumber);
          this.panDetailMessage = response.message;
          this.communicationService.sendApiHitSignal();
          this.authService.setAuthorizationStatus(true);

// Get current date and time using toLocaleString()
const currentDate = new Date();
const formattedDate = currentDate.toLocaleString('en-GB', { timeZone: 'UTC', hour12: false });
this.reportService.setDate(formattedDate);


        }
        this.prodSearched = true;
      },
      (error) => {
        this.show = true; 
        this.isLoading = false;
        console.error(error);
        if (error.error.status === 'Failed' && error.error.statusCode === 404 && error.error.message === 'Xcibil Report not found') {
          this.showDetail = true;
          this.panDetail = error.error.data
          this.reportService.setPanuatDetail(error.error.data); 
          this.reportService.setPan(this.panNumber);
          this.panDetailMessage = error.error.message;
          this.communicationService.sendApiHitSignal();
          this.authService.setAuthorizationStatus(true);


          
        }  else {
          this.panDetailMessage = error.error.message
        }
       
      }
    );
  }



  showDetailUAT: boolean = false;
  searchXCIBILuat() {
    if (!this.validateFormuat()) {
      return;
    }
    this.deleteFormData()

    this.isLoading = true;
    this.showDetailUAT = false;

    const url = ProjParams.apiurlNew + `public/apiRoute/generateXcibilReportUAT/?pan_no=${this.panNumberuat}`;
  
    const headers = new HttpHeaders({
      'clientId': this.clientIduat,
      'secretKey': this.secretKeyuat
    });
  
    this.http.get(url, { headers }).subscribe(
      (response: any) => {
        console.log(response);
        this.isLoading = false;
        this.showUAT = true;
        this.mode = 'S'
        if(response.message ===  'Contact Support to recharge the Hits')
          {
          this.panuatDetailMessage = response.message;
          }
          else if(response.message ===  'Service is Not Active ')
            {
            this.panuatDetailMessage = response.message;
            }
         else {
          this.showDetailUAT = true
          this.panuatDetail = response.data
          this.reportService.setPanuatDetail(response.data); 
          this.reportService.setPan(this.panNumber);
          this.panuatDetailMessage = response.message;
          this.communicationService.sendApiHitSignal();
          this.authService.setAuthorizationStatus(true);


          const currentDate = new Date();
const formattedDate = currentDate.toLocaleString('en-GB', { timeZone: 'UTC', hour12: false });
this.reportService.setDate(formattedDate);

        }

        this.uatSearched = true;
      },
      (error) => {
        this.showUAT = true;
        this.isLoading = false;
        console.error(error);
        if (error.error.status === 'Failed' && error.error.statusCode === 404 && error.error.message === 'Xcibil Report not found') {
          this.showDetailUAT = true
          this.panuatDetail = error.error.data
          this.reportService.setPanuatDetail(error.error.data); 
          this.reportService.setPan(this.panNumber);
          this.panuatDetailMessage = error.error.message;
          console.log('uat error res:', error.error.message)
          this.communicationService.sendApiHitSignal();
          this.authService.setAuthorizationStatus(true);


        } else {
          this.panuatDetailMessage = error.error.message
        }
       
      }
    );
  }


  hide(){
    this.show = false;
    // this.clientId = '';
    // this.secretKey = '';
    this.panDetail = '';
    this.panDetailMessage = '';
    this.panNumber = '';
  }

  hideUAT(){
    this.showUAT = false;
    // this.clientIduat = '';
    // this.secretKeyuat = '';
    this.panuatDetail = '';
    this.panuatDetailMessage = '';
    this.panNumberuat = ''
  }

  goBack(){
    this.router.navigate(['/api/xcibil-report'])
  }

  navigateToXcibilReport(){
    if (this.show) {
      this.saveFormData()
    } else{
      this.saveFormDatauat()
    }
    this.router.navigate(['/api/xcibil-report/search-xcibil/view-xcibil-report'])
  }

  convertToPDF() {
    // Select the pdf-content div
    const element = document.getElementById('pdf-content');

    // Options for html2pdf
    const options = {
      margin: 1,
      filename: 'xcibil_report.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    // Start the conversion process
    html2pdf().from(element).set(options).save();
  }
  
  validateForm(): boolean {
    let isValid = true;

    isValid = this.validateField('clientId') && isValid;
    isValid = this.validateField('secretKey') && isValid;
    isValid = this.validateField('panNumber') && isValid;

    return isValid;
  }
  clientIdError: string;
  secretKeyError: string;
  panNumberError: string;

  validateField(field: string): boolean {
    let isValid = true;
    let value = '';
    let errorMessage = '';
    let isPAN = false;

    switch (field) {
      case 'clientId':
        value = this.clientId;
        errorMessage = 'Please enter a Client ID';
        this.clientIdError = '';
        break;
      case 'secretKey':
        value = this.secretKey;
        errorMessage = 'Please enter a Secret Key';
        this.secretKeyError = '';
        break;
      case 'panNumber':
        value = this.panNumber;
        if (!value) {
          errorMessage = 'Please enter the PAN number';
          isValid = false; // Mark the field as invalid
        } else {
          errorMessage = 'Please enter a valid PAN Number';
          isPAN = true; // Set isPAN to true for further validation
          this.panNumberError = ''; // Clear any previous error message
        }
        break;
    }

    const element = document.getElementById(field + 'Input') as HTMLInputElement;

    if (isPAN) {
      isValid = this.validatePAN(value);
    } else {
      isValid = !!value;
    }

    if (!isValid) {
      this.highlightField(element);
      this.setErrorMessage(field, errorMessage);
    } else {
      this.resetFieldStyle(element);
      this.setErrorMessage(field, '');
    }

    return isValid;
  }

  setErrorMessage(field: string, message: string) {
    switch (field) {
      case 'clientId':
        this.clientIdError = message;
        break;
      case 'secretKey':
        this.secretKeyError = message;
        break;
      case 'panNumber':
        this.panNumberError = message;
        break;
    }
  }

  clientIdErroruat: string;
  secretKeyErroruat: string;
  panNumberErroruat: string;


  validateFormuat(): boolean {
    let isValid = true;

    isValid = this.validateFielduat('clientIduat') && isValid;
    isValid = this.validateFielduat('secretKeyuat') && isValid;
    isValid = this.validateFielduat('panNumberuat') && isValid;

    return isValid;
  }


  validateFielduat(field: string): boolean {
    let isValid = true;
    let value = '';
    let errorMessageuat = '';
    let isPAN = false;
  
    switch (field) {
      case 'clientIduat':
        value = this.clientIduat;
        errorMessageuat = 'Please enter a Client ID';
        this.clientIdErroruat = '';
        break;
      case 'secretKeyuat':
        value = this.secretKeyuat;
        errorMessageuat = 'Please enter a Secret Key';
        this.secretKeyErroruat = '';
        break;
      case 'panNumberuat':
        value = this.panNumberuat;
        if (!value) {
          errorMessageuat = 'Please enter the PAN number';
          isValid = false; // Mark the field as invalid
        } else {
          errorMessageuat = 'Please enter a valid PAN Number';
          isPAN = true; // Set isPAN to true for further validation
          this.panNumberErroruat = ''; // Clear any previous error message
        }
        break;
    }
  
    const elementuat = document.getElementById(field + 'Input') as HTMLInputElement;
  
    if (isPAN && isValid) {
      isValid = this.validatePAN(value); // Validate PAN format if necessary
    }
  
    if (!isValid) {
      this.highlightFielduat(elementuat);
      this.setErrorMessageuat(field, errorMessageuat);
    } else {
      this.resetFieldStyleuat(elementuat);
      this.setErrorMessageuat(field, '');
    }
  
    return isValid;
  }

  setErrorMessageuat(field: string, message: string) {
    switch (field) {
      case 'clientIduat':
        this.clientIdErroruat = message;
        break;
      case 'secretKeyuat':
        this.secretKeyErroruat = message;
        break;
      case 'panNumberuat':
        this.panNumberErroruat = message;
        break;
    }
  }
  toUpperCase(event: any) {
    const input = event.target as HTMLInputElement;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    input.value = input.value.toUpperCase();
    this.panNumber = input.value; // Update the model
    input.setSelectionRange(start, end);
    this.resetBorder(event); // Call resetBorder here instead of in the template
  }

  resetBorder(event: Event) {
    const element = event.target as HTMLInputElement;
    element.style.border = '';
    element.style.boxShadow = '';
  }

  highlightField(element: HTMLElement) {
    // element.style.border = '0.3px solid red';
    element.style.boxShadow = '0 0 6px red';
  
    setTimeout(() => {
      this.resetFieldStyle(element);
    }, 3000); // Reset after 3 seconds
  }
  
  resetFieldStyle(element: HTMLElement) {
    // element.style.border = '';
    element.style.boxShadow = '';
  }


  toUpperCaseuat(event: any) {
    const input = event.target as HTMLInputElement;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    input.value = input.value.toUpperCase();
    this.panNumberuat = input.value; // Update the model
    input.setSelectionRange(start, end);
    this.resetBorderuat(event); // Call resetBorder here instead of in the template
  }

  resetBorderuat(event: Event) {
    const element = event.target as HTMLInputElement;
    element.style.border = '';
    element.style.boxShadow = '';
  }

  highlightFielduat(element: HTMLElement) {
    // element.style.border = '0.3px solid red';
    element.style.boxShadow = '0 0 6px red';
  
    setTimeout(() => {
      this.resetFieldStyleuat(element);
    }, 3000); // Reset after 3 seconds
  }
  
  resetFieldStyleuat(element: HTMLElement) {
    // element.style.border = '';
    element.style.boxShadow = '';
  }


  validatePAN(pan: string): boolean {
    const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    return panPattern.test(pan);
  }

  validatePANuat(pan: string): boolean {
    const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    return panPattern.test(pan);
  }


  
  
  

}
